import React, { useState } from 'react'
import useFetch from '../../../hooks/useAxios'
import MyWalletBos from './wallete/MyWalletBos'
import MyWalleteShaba from './wallete/MyWalleteShaba'
import WalletTable from './wallete/WalletTable'
import WithdrawModal from './wallete/WithdrawModal'

const Wallete = () => {
  const [withdraw,setWithdraw]=useState(false)
  const [walletInfo, setwalletInfo] = useState()
  const fetchwallet = useFetch({
    method: "get",
    url: "api/wallet",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setwalletInfo(res.data)
      
    }
  });
  return (
<div>
{ walletInfo && 
    <div>
        <MyWalletBos setWithdraw={()=>setWithdraw(true)} walletInfo={walletInfo} />
        <MyWalleteShaba walletInfo={walletInfo}/>
        <WalletTable walletInfo={walletInfo}/>
    </div>}
    {
      withdraw && <WithdrawModal closeModal={()=>setWithdraw(false)} />
    }
</div>
  )
}

export default Wallete